import { CheckoutStripeInput } from "@/offering/template_offering_checkout_stripe_base";
import { FormikErrors, FormikTouched } from "formik";

export function getCheckoutErrorFieldId(
  errors: FormikErrors<CheckoutStripeInput>,
  touched: FormikTouched<CheckoutStripeInput>
) {
  const errorOrder: Array<keyof CheckoutStripeInput> = [
    "fullName",
    "phoneNumber",
    "email",
    "billingFullName",
    "billingPhoneNumber",
    "billingEmail",
    "companyName",
    "billingStreetAddress",
    "billingCity",
    "billingPostalCode",
    "billingCountry",
    "billingTax",
    "paymentComplete",
    "termsChecked",
    "membershipNumber",
  ];
  for (const errorKey of errorOrder) {
    if (errors[errorKey]?.length && touched[errorKey]) {
      return errorKey;
    }
  }
}
